import { translate } from '@micro-apps/env';
import React, { ReactNode } from 'react';
import { IconAlert } from '../../icon';

export default class ErrorBoundary extends React.Component<
	{ children: ReactNode; setError?: React.Dispatch<React.SetStateAction<boolean>> },
	{ hasError: boolean }
> {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError() {
		// Update state so the next render will show the fallback UI.
		// Can only be done in class component
		return { hasError: true };
	}

	override render() {
		if (this.state.hasError) {
			if (this.props.setError) {
				this.props.setError(true);
			}
			// You can render any custom fallback UI
			return (
				<div className="pt-250">
					<div className="flex flex flex-col gap-100 items-start spacing-inline-s bg-error-container-subtle text-error-text rounded-[5px] py-[14px] px-[10px]">
						<div className="flex items-start spacing-inline-xs">
							<IconAlert width={20} height={20} />
							<span className="text-caption">
								{translate('We’re sorry, an unexpected error has occurred. Please try again.')}
							</span>
						</div>
					</div>
				</div>
			);
		}

		return this.props.children;
	}
}
